import { GET_CANDIDATE_TRANSCRIPT } from "../lib/urls";

const TRANSCRIPT_FETCH_CONCURRENCY = 4;

export function mergePreservedTranscript(prev, next) {
  if (!prev || !next) {
    return next;
  }
  const sameCandidate = prev.id && next.id === prev.id;
  const prevSession = prev.interview_session_id;
  const nextSession = next.interview_session_id;
  const sameSession =
    prevSession && (nextSession === prevSession || !nextSession);
  if (sameCandidate && sameSession) {
    return {
      ...next,
      interview_session_id: nextSession || prevSession,
      interview_responses: prev.interview_responses || [],
    };
  }
  return next;
}

export async function fetchCandidateTranscript(
  companyId,
  jobId,
  candidateId,
  token,
  signal,
  sessionId
) {
  const response = await fetch(
    GET_CANDIDATE_TRANSCRIPT(companyId, jobId, candidateId, sessionId),
    {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    }
  );
  if (!response.ok) {
    const error = new Error("Failed to load transcript");
    error.status = response.status;
    throw error;
  }
  const data = await response.json();
  return data.interview_responses || [];
}

export async function fetchTranscriptsByCandidateId(
  companyId,
  jobId,
  candidateIds,
  token
) {
  const ids = candidateIds.filter(Boolean);
  const transcripts = new Map();
  let cursor = 0;

  async function worker() {
    while (cursor < ids.length) {
      const index = cursor;
      cursor += 1;
      const candidateId = ids[index];
      transcripts.set(
        candidateId,
        await fetchCandidateTranscript(companyId, jobId, candidateId, token)
      );
    }
  }

  const workerCount = Math.min(TRANSCRIPT_FETCH_CONCURRENCY, ids.length);
  await Promise.all(Array.from({ length: workerCount }, worker));
  return transcripts;
}
